import {Extension} from 'aphrodite/no-important';

/**
 * Custom selectors to support descendants, direct children and specific classes
 * Ref: https://github.com/Khan/aphrodite/pull/368/commits/893be22f104d8596fa25109268dae7cdcbd52c9b
 *
 * Example of direct children, to handle { pointerEvents: 'box-none'}:
 * {
 *   pointerEvents: 'none',
 *   '> *': {
 *     pointerEvents: 'auto',
 *   },
 * }
 */
export const customSelectors: Extension[] = [
  {
    // Handle targeting all descendands i.e. .myForm_ae213c .my-descendant-class
    selectorHandler: (selector, baseSelector, generateSubtreeStyles) => {
      if (selector[0] !== ' ') {
        return null;
      }
      return generateSubtreeStyles(`${baseSelector}${selector}`);
    },
  },
  {
    // Handle targeting direct child descendands i.e. .myForm_ae213c > .my-descendant-class
    selectorHandler: (selector, baseSelector, generateSubtreeStyles) => {
      if (selector[0] !== '>') {
        return null;
      }
      return generateSubtreeStyles(`${baseSelector}${selector}`);
    },
  },
  {
    // Handle targeting baseSelector when it has specific class
    selectorHandler: (selector, baseSelector, generateSubtreeStyles) => {
      if (selector[0] !== '.') {
        return null;
      }
      return generateSubtreeStyles(`${baseSelector}${selector}`);
    },
  },
];
